import { render, staticRenderFns } from "./item_options.vue?vue&type=template&id=4a5d862e"
import script from "./item_options.vue?vue&type=script&lang=js"
export * from "./item_options.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports